/* eslint-disable max-len */
const link = 'iurisprudentia';
const iurisprudentia = {
  name: 'Iurisprudentia',
  col_id: null,
  editionName: 'Iurisprudentia',
  editionLink: link,
  logo: 'iurisprudentiaSW.png',
  background: 'eugenHuber.png',
  colors: {
    primaryColor: '36, 74, 93',
    primaryColorLight: '65, 135, 169',
    primaryColorDark: '10, 10, 10',
    secondaryColor: '61,125,156',
  },
  footerLogos: [
    {
      link: 'https://www.rwi.uzh.ch/boente/',
      src: 'logo-uzh.svg',
      alt: 'Universität Zürich',
    },
    {
      link: 'https://readcoop.eu/readsearch/',
      src: 'logo-readcoop.svg',
      alt: 'Read COOP',
    },
  ],
  staticDirectory: [],
  crowdDirectory: [],
};

export default iurisprudentia;
